export const _setParticipantName = (state, action) => {
  state.participant.participantName = action.payload;
};

export const _setIsProfA1DataLoaded = (state, action) => {
  state.isProfA1DataLoaded = action.payload;
};

export const _setcdcNumber = (state, action) => {
  state.cdcNumber = action.payload;
};

export const _setDob = (state, action) => {
  state.participant.dob = action.payload;
};

export const _setCountyofLastLegalResidence = (state, action) => {
  state.countyofLastLegalResidence = action.payload;
};

export const _setParoleRegion = (state, action) => {
  state.paroleRegion = action.payload;
};

export const _setSat = (state, action) => {
  state.sat = action.payload;
};

export const _setSatShortName = (state, action) => {
  state.satShortName = action.payload;
};

export const _setCsarScore = (state, action) => {
  state.CSRAScore = action.payload;
};

export const _setAsiScore = (state, action) => {
  state.ASIScore = action.payload;
};

export const _setSecondaryScore = (state, action) => {
  state.secondaryScore = action.payload;
};

export const _setPermanentAddress = (state, action) => {
  state.permanentAddress = action.payload;
};

export const _setPermanentCity = (state, action) => {
  state.permanentCity = action.payload;
};

export const _setPermanentZipCode = (state, action) => {
  state.permanentZipCode = action.payload;
};

export const _setTelephoneNumber = (state, action) => {
  state.permanentTelephone = action.payload;
};

export const _setMaritalStatusId = (state, action) => {
  state.maritalStatusId = action.payload;
};

export const _setEthnicGroupId = (state, action) => {
  state.participant.ethnicGroupId = action.payload;
};

export const _setPrimaryLanguage = (state, action) => {
  state.primaryLanguage = action.payload;
};

export const _setHighestEducationId = (state, action) => {
  state.highestEducationId = action.payload;
};

export const _setUsualOccupation = (state, action) => {
  state.usualOccupation = action.payload;
};

export const _setYears = (state, action) => {
  state.years = action.payload;
};

export const _setNumberofChildren = (state, action) => {
  state.numberofChildren = action.payload;
};

export const _setAges = (state, action) => {
  state.Ages = action.payload;
};

export const _setIsCSBOrCPSInvolved = (state, action) => {
  state.isCSBOrCPSInvolved = action.payload;
};

export const _setChildrenLiveWith = (state, action) => {
  state.childrenLiveWith = action.payload;
};

export const _setEmergencyContact1Name = (state, action) => {
  state.emergencyContact1Name = action.payload;
};

export const _setEmergencyContact1Address = (state, action) => {
  state.emergencyContact1Address = action.payload;
};

export const _setEmergencyContact1City = (state, action) => {
  state.emergencyContact1City = action.payload;
};

export const _setEmergencyContact1Phone = (state, action) => {
  state.emergencyContact1Phone = action.payload;
};

export const _setEmergencyContact1Relationship = (state, action) => {
  state.emergencyContact1Relationship = action.payload;
};

export const _setEmergencyContact2Name = (state, action) => {
  state.emergencyContact2Name = action.payload;
};

export const _setEmergencyContact2Address = (state, action) => {
  state.emergencyContact2Address = action.payload;
};

export const _setEmergencyContact2City = (state, action) => {
  state.emergencyContact2City = action.payload;
};

export const _setEmergencyContact2Phone = (state, action) => {
  state.emergencyContact2Phone = action.payload;
};

export const _setEmergencyContact2Relationship = (state, action) => {
  state.emergencyContact2Relationship = action.payload;
};

export const _setClassifiedCCCMS = (state, action) => {
  state.classifiedCCCMS = action.payload;
};

export const _setClassifiedCCCMSYear = (state, action) => {
  state.classifiedCCCMSYear = action.payload;
};

export const _setClassifiedCCCMSClearedYear = (state, action) => {
  state.classifiedCCCMSClearedYear = action.payload;
};

export const _setMedComments = (state, action) => {
  state.medComments = action.payload;
};

export const _setMedicineName1 = (state, action) => {
  state.medicineName1 = action.payload;
};

export const _setMedicineName2 = (state, action) => {
  state.medicineName2 = action.payload;
};

export const _setMedicineName3 = (state, action) => {
  state.medicineName3 = action.payload;
};

export const _setMedicineCondition1 = (state, action) => {
  state.medicineCondition1 = action.payload;
};

export const _setMedicineCondition2 = (state, action) => {
  state.medicineCondition2 = action.payload;
};

export const _setMedicineCondition3 = (state, action) => {
  state.medicineCondition3 = action.payload;
};

export const _setADA = (state, action) => {
  state.ADA = action.payload;
};

export const _setVeteran = (state, action) => {
  state.veteran = action.payload;
};
